import React from 'react';
import { Link } from 'react-router-dom';

import destinationBg from '../../assets/img/bg/destination.png';
import desIcon1 from '../../assets/img/icons/destination-icon-1.png';
import desIcon2 from '../../assets/img/icons/destination-icon-2.png';
import destination1 from '../../assets/img/destination/destination-1-1.png';
import tokyoImg from '../../assets/img/tokyo.webp';
import destination3 from '../../assets/img/destination/destination-1-3.jpg';
import destination4 from '../../assets/img/destination/destination-1-4.jpg';

const Destinations = () => {
    const destinations = [
        {
            id: 1,
            image: destination1,
            title: "thailand trip",
            discount: "30% discount",
            active: true
        },
        {
            id: 2,
            image: tokyoImg,
            title: "tokyo",
            discount: "30% discount",
            active: false
        },
        {
            id: 3,
            image: destination3,
            title: "spain",
            discount: "30% discount",
            active: false
        },
        {
            id: 4,
            image: destination4,
            title: "spain",
            discount: "30% discount",
            active: false
        }
    ];

    return (
        <section
            className="vs-destination-style1 bg-third-theme-12 overflow-hidden space"
            style={{ backgroundImage: `url(${destinationBg})` }}
        >
            <img
                className="des-icon-1 animate-parachute"
                src={desIcon1}
                alt="icon"
            />
            <img
                className="des-icon-2 animate-tree"
                src={desIcon2}
                alt="icon"
            />
            <div className="container">
                <div className="row">
                    <div className="col-lg-auto mx-auto">
                        <div className="title-area text-center">
                            <span className="sec-subtitle fade-anim" data-direction="top">
                                Top Destinations
                            </span>
                            <h2 className="sec-title move-anim">Discover Top Destinations</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="destination-box-wrapper">
                            {destinations.map((destination) => (
                                <div
                                    key={destination.id}
                                    className={`destination-box ${destination.active ? 'active' : ''}`}
                                >
                                    <div className="destination-thumb">
                                        <img
                                            src={destination.image}
                                            alt={destination.title}
                                            className="w-100"
                                        />
                                    </div>
                                    <div className="destination-content">
                                        <div className="info">
                                            <h4 className="text-white text-capitalize">
                                                <Link to="/DestinationDetails">{destination.title}</Link>
                                            </h4>
                                            <span className="text-theme-color d-block">{destination.discount}</span>
                                        </div>
                                        <Link to="/DestinationDetails" className="icon bg-theme-color text-white-color">
                                            <i className="fa-solid fa-location-dot"></i>
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="text-center mt-50 btn-trigger btn-bounce">
                            <Link to="/DestinationDetails" className="vs-btn style4">
                                <span>view more</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Destinations;